import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabroundtrip() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Cab Round Trip',
    heading: 'Sanavi Travels: Pune to Shirdi Cab Round Trip',
    headingDescription: 'Sanavi Travels offers reliable Pune to Shirdi Cab Round Trip services, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and groups traveling from Pune to Shirdi for religious visits or leisure. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and stress-free journey. With professional chauffeurs, flexible round-trip packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and comfortable travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Shirdi and nearby attractions such as Sai Baba Temple, Dwarkamai, Chavadi, and Lendi Baug. Choose Sanavi Travels for trusted Pune to Shirdi cab round-trip services, delivering comfort, safety, and a memorable spiritual travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the most revered shrine in Shirdi, dedicated to the spiritual saint Sai Baba. Devotees from across India and the world visit to offer prayers and seek blessings. The temple complex includes the Samadhi Mandir, Dwarkamai Masjid, and Chavadi, offering a deeply spiritual experience."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai Masjid is a historic mosque in Shirdi where Sai Baba spent a major part of his life. It houses sacred relics and personal belongings of the saint. The mosque remains a center of devotion and reflection for pilgrims."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a small structure where Sai Baba used to sleep on alternate nights. It holds historical significance and offers devotees a glimpse into the saint’s daily life. Devotees visit Chavadi to pay respects and experience the spiritual ambiance."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a cultural attraction near Shirdi, showcasing traditional rural life of Maharashtra. Visitors can explore farmhouses, local crafts, and folk performances, gaining insight into the region’s heritage and lifestyle."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy is a popular amusement and water park near Shirdi, offering pools, water rides, and family-friendly attractions. It provides a fun and recreational option for tourists traveling with children or looking for leisure activities."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located near Shirdi, is famous for its Shani Temple and the unique tradition of houses without doors. Devotees visit to seek blessings from Lord Shani and experience the village’s distinctive cultural heritage."
  },
  {
    "title": "Khandoba Temple, Shirdi",
    "description": "This historic temple dedicated to Lord Khandoba is located near Shirdi and is visited by devotees seeking spiritual blessings. The temple showcases traditional Maharashtrian temple architecture."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Samadhi Mandir is the final resting place of Sai Baba within the temple complex. It is the focal point of worship and rituals, attracting countless devotees who come to offer prayers and participate in ceremonies."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a garden adjacent to the Sai Baba Temple, featuring trees planted by Sai Baba himself. Visitors enjoy peaceful walks, meditation, and reflections amidst the serene greenery."
  },
  {
    "title": "Anand Sagar Lake",
    "description": "Anand Sagar Lake is a scenic spot near Shirdi, surrounded by gardens and walking paths. It is ideal for relaxation, photography, and enjoying calm natural beauty away from the busy temple area."
  }
]
,




"services": [
  {
    "name": "Pune to Shirdi Cab Round Trip",
    "description": "Pune to Shirdi Cab Round Trip offers travelers a comfortable and convenient way to visit Shirdi and return to Pune without any hassle. Fully air-conditioned vehicles with spacious seating and ample luggage space ensure a smooth journey. Professional chauffeurs provide safe driving, route planning, and timely pickups, making the trip stress-free. Ideal for families, groups, and corporate travelers seeking a reliable and affordable round-trip experience."
  },
  {
    "name": "Shirdi Cab from Pune",
    "description": "Shirdi Cab from Pune provides a dependable travel solution for passengers commuting between Pune and Shirdi. Air-conditioned cabs with professional chauffeurs ensure a comfortable, safe, and timely journey. Suitable for families, groups, or solo travelers, this service allows flexible pickup and drop locations, making travel to Shirdi convenient and hassle-free."
  },
  {
    "name": "AC Cab Pune to Shirdi",
    "description": "AC Cab Pune to Shirdi ensures a cool and comfortable long-distance journey. Fully air-conditioned vehicles with spacious seating and luggage space make the trip pleasant, especially during hot weather. Experienced chauffeurs handle navigation, traffic, and timings efficiently. Perfect for families, corporate travelers, or tourists seeking comfort, convenience, and safety."
  },
  {
    "name": "Sai Baba Darshan Cab Pune",
    "description": "Sai Baba Darshan Cab Pune is specially designed for pilgrims traveling to Shirdi to visit the Sai Baba Temple. Comfortable, fully air-conditioned vehicles with professional chauffeurs ensure safe and timely travel. This service is ideal for families, groups, or solo devotees looking for a stress-free, organized pilgrimage experience."
  },
  {
    "name": "Family Cab Shirdi",
    "description": "Family Cab Shirdi provides a spacious and comfortable travel option for families visiting Shirdi from Pune. Air-conditioned cabs with ample luggage space and professional drivers ensure a safe and enjoyable journey. Ideal for one-day trips, weekend getaways, or religious visits, this service prioritizes family convenience and comfort throughout the trip."
  },
  {
    "name": "Affordable Cab Shirdi",
    "description": "Affordable Cab Shirdi offers budget-friendly travel options for passengers visiting Shirdi from Pune. Fully air-conditioned vehicles with experienced chauffeurs ensure a smooth and reliable journey. Perfect for students, families, and group travelers seeking economical yet comfortable travel solutions."
  },
  {
    "name": "Chauffeur Driven Cab Shirdi",
    "description": "Chauffeur Driven Cab Shirdi ensures a professional, stress-free journey from Pune to Shirdi. Experienced drivers manage navigation, traffic, and route planning while passengers enjoy a comfortable ride in fully air-conditioned, spacious vehicles. Suitable for families, corporate groups, or pilgrims seeking safety and convenience."
  },
  {
    "name": "Best Cab Pune to Shirdi",
    "description": "Best Cab Pune to Shirdi provides a premium travel experience with well-maintained, fully air-conditioned vehicles. Professional chauffeurs ensure punctual pickups, safe driving, and smooth navigation. Ideal for families, groups, or corporate travelers seeking a comfortable and reliable journey to Shirdi."
  },
  {
    "name": "Pune Shirdi Taxi",
    "description": "Pune Shirdi Taxi is a dependable travel solution for long-distance trips between Pune and Shirdi. Spacious, air-conditioned vehicles with professional drivers provide comfort, safety, and reliability. Flexible pickup and drop options make this service suitable for families, groups, and corporate travelers seeking convenience."
  },
  {
    "name": "Religious Tour Cab Pune",
    "description": "Religious Tour Cab Pune offers an organized and comfortable travel option for pilgrims visiting Shirdi and other religious destinations. Fully air-conditioned cabs with professional chauffeurs provide a safe, timely, and convenient journey. Perfect for family trips, group tours, or corporate religious outings."
  },
  {
    "name": "Temple Darshan Cab Pune",
    "description": "Temple Darshan Cab Pune is designed for devotees traveling from Pune to Shirdi for Sai Baba darshan. Comfortable, air-conditioned vehicles with experienced chauffeurs ensure punctual arrivals, smooth navigation, and a hassle-free pilgrimage experience."
  },
  {
    "name": "One Day Trip Cab Shirdi",
    "description": "One Day Trip Cab Shirdi offers a convenient option for travelers planning a single-day visit from Pune to Shirdi. Fully air-conditioned, spacious vehicles with professional drivers ensure a comfortable, timely, and safe journey, making it ideal for families, groups, or solo travelers."
  },
  {
    "name": "Tourist Cab Shirdi",
    "description": "Tourist Cab Shirdi caters to travelers seeking a comfortable journey for sightseeing or religious visits from Pune to Shirdi. Spacious, air-conditioned vehicles with professional chauffeurs ensure a safe, timely, and enjoyable experience. Perfect for families, groups, or solo tourists."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows passengers to conveniently book Pune to Shirdi cabs anytime, anywhere. Users can select cab type, pickup and drop locations, date, and trip duration with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs provide a smooth, safe, and stress-free journey."
  },
  {
    "name": "Shirdi Travel Cab",
    "description": "Shirdi Travel Cab offers a reliable and comfortable travel option for visitors from Pune to Shirdi. Fully air-conditioned vehicles with spacious seating and professional chauffeurs ensure a smooth, safe, and enjoyable journey. Suitable for families, groups, and corporate travelers, this service guarantees convenience, comfort, and reliability throughout the trip."
  }
],
"tableData": [
  ["Pune to Shirdi Cab Round Trip", "Shirdi Cab from Pune"],
  ["AC Cab Pune to Shirdi", "Sai Baba Darshan Cab Pune"],
  ["Family Cab Shirdi", "Affordable Cab Shirdi"],
  ["Chauffeur Driven Cab Shirdi", "Best Cab Pune to Shirdi"],
  ["Pune Shirdi Taxi", "Religious Tour Cab Pune"],
  ["Temple Darshan Cab Pune", "One Day Trip Cab Shirdi"],
  ["Tourist Cab Shirdi", "Online Cab Booking Pune"],
  ["Shirdi Travel Cab", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Cab Round Trip with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable cab services for a round trip from Pune to Shirdi, ideal for pilgrimages, family travel, and group outings."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced vehicles for a smooth and enjoyable round trip from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune to Shirdi routes to ensure safe, timely, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Pune to Shirdi round trips, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary updates."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from customizable round-trip packages according to your Pune to Shirdi travel needs and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Shirdi round trips."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Shirdi cab round trip services?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable cab services for a round trip from Pune to Shirdi.'
  },
  {
    question: 'How can I book a Pune to Shirdi round trip cab?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Shirdi travel?',
    answer: 'Sanavi Travels offers sedans, SUVs, and premium cars suitable for round trips from Pune to Shirdi.'
  },
  {
    question: 'Are drivers experienced for the Pune–Shirdi route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune to Shirdi routes to ensure safe and smooth travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off in Shirdi or nearby locations.'
  },
  {
    question: 'Is the round trip cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock services for bookings and travel assistance.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before each journey.'
  },
  {
    question: 'What payment options are available for Pune to Shirdi round trip bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Shirdi trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Patil',
    feedback: 'Booked a Pune to Shirdi round trip with Sanavi Travels. Excellent service, comfortable cab, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Deshmukh',
    feedback: 'Amazing experience! The cab was clean, journey was smooth, and the round trip was perfectly managed by Sanavi Travels.',
    rating: 5
  }
];






















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab Round Trip - Sanavi Travels",
  "description": "Book Pune to Shirdi round-trip cabs with Sanavi Travels. AC and comfortable cabs for Sai Baba darshan, family trips, religious tours, one-day trips, pilgrimage travel, and chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Shirdi Cab Round Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and comfortable cabs from Pune to Shirdi for round trips with Sanavi Travels. Ideal for Sai Baba darshan, family trips, religious tours, one-day trips, and safe chauffeur-driven travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicabroundtrip;